
import { defineComponent, ref, computed } from 'vue'

import AppLogo from '@/components/atoms/AppLogo.vue'
import AppHero from '@/components/home/AppHero.vue'
import AppContent from '@/components/layout/AppContent.vue'

import SubscriptionPlans from '@/components/subscription/SubscriptionPlans.vue'

import { store } from '@/store'

export default defineComponent({
  name: 'Home',
  components: { AppLogo, AppHero, AppContent, SubscriptionPlans },
  setup() {
    const theme = computed(() => store.global.state.theme)
    const routes = store.route.state

    const vehicle = ref('truck')

    function signIn() {
      store.modal.showModal('SignIn')
    }

    return { store, signIn, theme, routes, vehicle }
  }
})
